import * as t from "./actions";

let initialState: IAdminModuleProps = {
  files: []
};

export default function (
  state = initialState,
  action: IPayload
): IAdminModuleProps {
  switch (action.type) {
    case t.GET_FAILED_REPORTS_SUCCESS:
      return { ...state, files: action.payload };

    case t.GET_FAILED_REPORTS_FAILURE:
      // TODO handle errors
      console.error("getReportFiles failed!");
      return state;

    case t.REGENERATE_REPORT_SUCCESS:
      return state;

    case t.REGENERATE_REPORT_FAILURE:
      console.error(`regenerateReport with id: ${action.payload} failed!`);
      return state;

    case t.RESEND_REPORT_FAILURE:
      console.error(`resendReport with id: ${action.payload} failed!`);
      return state;

    case t.RESEND_REPORT_SUCCESS:
      return state;

    case t.REGENERATE_SYSTEM_FAILURES_FAILURE:
      console.error(`regenerateSystemFailuers failed!`);
      return state;

    case t.REGENERATE_SYSTEM_FAILURES_SUCCESS:
      return state;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/modules/Admin/reducer.ts